import { Component, OnInit, Output, EventEmitter , Input} from '@angular/core';
import { Location } from '@angular/common';
import { ApiResource } from '../../resources/api.resource';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

declare var $: any;
declare var $e: any;

const globalCenterMapLat = 13.6915591;
const globalCenterMapLng = -89.2497134;
const globalMapZoom = 12;

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.scss']
})
export class PersonasComponent implements OnInit {

  @Output() configurationEmit = new EventEmitter();
  @Output() uuidOut: EventEmitter<any> = new EventEmitter();
  @Input() padre : String;

  public HeaderHtml = null;
  public FooterHtml = null;
  public menuHeaderHtml = null;
  public menuFooterHtml = null;
  public BotonesDeSlides = null;
  public sliderHtml = null;
  public tabsHtml = null;
  public responseUuid = null;
  public productsHtml = null;
  public customHtml = null;
  public habilitarPaginaBuscar = false;
  public mostrarActivos = false;
  public configuration = null;
  public formulario = null;
  public mapa = {};
  public departamentosEnCasoDeQueVengaVacioElNodo = [];
  public descargarDocumentos = false;
  public solucionesDavivienda = false;
  bancaHtml: boolean;

constructor(private resource: ApiResource, 
private api: ApiService,
 private rutaActiva: ActivatedRoute, 
 private router: Router, private location: Location) { }

// Método para leer parámetros de URL
private leerParametrosURL(): void {
  // Query parameters (?param=value&otro=valor)
  this.rutaActiva.queryParams.subscribe(params => {
    console.log('Query parameters recibidos:', params);
    
    // Manejar idioma desde URL (?lang=es)
    if (params['lang'] || params['idioma']) {
      const idioma = params['lang'] || params['idioma'];
      localStorage.setItem('idiomaEspañol', idioma === 'es' ? 'false' : 'true');
      console.log('Idioma desde URL:', idioma);
    }
    
    // Manejar UUID desde query params (?uuid=portal_principal_personas)
    if (params['uuid']) {
      localStorage.setItem('uuidBuscar', params['uuid']);
      localStorage.setItem('buscarHacia', 'personas');
      this.obtenerPagina(params['uuid']);
      console.log('UUID desde query params:', params['uuid']);
    }
    
  });

  // Route parameters (/personas/:uuid)
  this.rutaActiva.params.subscribe(params => {
    if (params['uuid'] && !this.rutaActiva.snapshot.queryParams['uuid']) {
      console.log('UUID desde route params:', params['uuid']);
      // Ya se maneja en el código existente con snapshot.params.uuid
    }
  });

  // Fragment para scroll a secciones (#seccion1)
  this.rutaActiva.fragment.subscribe(fragment => {
    if (fragment) {
      console.log('Fragment recibido:', fragment);
      setTimeout(() => {
        const element = document.getElementById(fragment);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1000);
    }
  });
}


  ngOnInit() {

        this.leerParametrosURL();


//console.log('personas--->uuidbuscar--->'+localStorage.getItem("uuidBuscar"));
//console.log('personas--->buscarHacia--->'+localStorage.getItem("buscarHacia"));
localStorage.setItem("componenteActual",'personas');

console.log('personas---->buscarHacia--->'+localStorage.getItem("buscarHacia"));
console.log('personas--->idiomaEspañol--->'+localStorage.getItem("idiomaEspañol"));

if( localStorage.getItem("idiomaEspañol")== 'true' || localStorage.getItem("idiomaEspañol")== 'true' ){

}else{
  localStorage.setItem("idiomaEspañol","false");
}


if(localStorage.getItem("buscarHacia") === 'personas'){

  this.obtenerPagina(localStorage.getItem("uuidBuscar"));  
  localStorage.setItem("buscarHacia",'');
  this.mostrarActivos = false;

  }else{
          if (this.rutaActiva.snapshot.params.uuid) {
      if (this.rutaActiva.snapshot.params.uuid == 'activos') {
        this.obtenerPaginaActivos("portal_principal_personas");
      }
      else if (this.rutaActiva.snapshot.params.uuid == 'documentos') {
        //console.log(this.rutaActiva.snapshot.params.uuid);
        this.obtenerPagina("portal_principal_personas");
        this.descargarDocumentos = true;
      }
      else if (this.rutaActiva.snapshot.params.uuid == 'solucionesDavivienda') {
        //console.log(this.rutaActiva.snapshot.params.uuid);
        this.obtenerPagina("portal_principal_personas");
        this.solucionesDavivienda = true;
      }
      else {

            this.obtenerPagina(this.rutaActiva.snapshot.params.uuid);
            this.mostrarActivos = false;       
      }
    }
    else {
     

      this.obtenerPagina("persona_principal");
      this.mostrarActivos = false;
    }
  }


  }

  

 

  /****************************************************************************************
   SI EL USUARIO SELECCIONA ACTIVOS DEL COMPONENTE HIJO LE ENVIARA LA PALABARA  "activos"
   EN ESE MOMENTO APUNTAREMOS A OBTENER EL HEADER Y FOOTER DE PERSONAS, Y EN DADO CASO NO 
   VENGA LA PALABRA "activos" BUSCARA MEDIANTE EL UUID EMITIDO :V
   ******************************************************************************************/
  public obtenerPagina(uuid): any {

    console.log('---obtenerPagina--- personas uuid--->'+uuid);
    $(".c-body").removeClass("background-banca");
    this.bancaHtml = false;
if(uuid.includes('empresas/')){
  console.log('ir a empresas--->');
  this.router.navigate([uuid]);
}

    if (uuid === 'mbaas') {
      console.log('ir a mbaas--->');
      this.router.navigate(['/mbaas']);
      return;
    }

    if (uuid == "activos") {
      this.obtenerPaginaActivos("portal_principal_personas");
    }
    else if (uuid == "documentos") {
      console.log(uuid);
      this.descargarDocumentos = true;


      let modalForm = $('#documentos');

      if (modalForm.hasClass('active')) {
        $('body').removeClass('overflow-hidden');
      } else {
        $('body').addClass('overflow-hidden');
      }

      modalForm.toggleClass('active');

    }
    else if (uuid == "solucionesDavivienda") {
      console.log(uuid);
      this.solucionesDavivienda = true;

      let modalForm = $('#soluciones');

      if (modalForm.hasClass('active')) {
        $('body').removeClass('overflow-hidden');
      } else {
        $('body').addClass('overflow-hidden');
      }

      modalForm.toggleClass('active');

    }
    else if(uuid === 'shedule_appointment'){

      this.mostrarActivos = false;
      this.habilitarPaginaBuscar = true;
      this.sliderHtml = null;
      this.BotonesDeSlides = null;
      this.tabsHtml = null;
      this.responseUuid = null;
      this.productsHtml = null;
      this.customHtml = null;
      this.sliderHtml = null;

      this.habilitarPaginaBuscar = false;

      this.bancaHtml = true;
      this.initFullpage();
      $(".c-body").removeClass("overflow-hidden");
      $(".c-body").addClass("background-banca");
        
    }else{

      this.mostrarActivos = false;
      this.habilitarPaginaBuscar = true;
      this.sliderHtml = null;
      this.BotonesDeSlides = null;
      this.tabsHtml = null;
      this.responseUuid = null;
      this.productsHtml = null;
      this.customHtml = null;
      this.sliderHtml = null;
      this.bancaHtml = false;

      this.habilitarPaginaBuscar = false;


      this.resource.obtenerHtmlPorUUID(uuid).subscribe(
        (resp) => {
          // console.warn("resp", resp);
          console.log("redirigiendo......");
          this.responseUuid = resp;

          for (let web of resp.elementos_web) {
            if (web.posicion == 'Pre-Header') {
              this.HeaderHtml = web;
            }
            else if (web.posicion == 'Footer') {
              this.FooterHtml = web;
            }
          }

          //verificar si viene formulario
          if (resp.details.formulario) {
            this.formulario = resp.details.formulario;
          }
          else {
            this.formulario = null;
          }

          this.menuFooterHtml = resp.elementos_footer;
          this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);


          // la pagina es de tipo custom
          if (resp.details.tabs == null && resp.details.products == null && resp.details.slides == null) {
            this.customHtml = resp.details;
            console.warn("custom");
          }
          else {
            this.customHtml = null;
          }

          // la pagina es de tipo slides
          if (resp.details.slides != null) {
            this.BotonesDeSlides = this.crearBotonesDeSlides(resp.details.slides);
            this.sliderHtml = this.procesarSlides(resp.details.slides);
          }
          else {
            this.BotonesDeSlides = null;
            this.sliderHtml = null;
          }


          //la pagina es de tipo tabs
          if (resp.details.tabs != null) {
            this.tabsHtml = resp.details;
          }
          else {
            this.tabsHtml = null;
          }


          //la pagina es de tipo producs
          if (resp.details.products != null) {
            this.productsHtml = resp.details;
          }
          else {
            this.productsHtml = null;
          }

          this.configuration = resp.configuration;

          localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

          this.initFullpage();
          $(".c-body").removeClass("overflow-hidden");
        }
      );
    }
  }

  public obtenerPaginaActivos(uuid): any {
    this.habilitarPaginaBuscar = true;
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.tabsHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;
    this.sliderHtml = null;

    this.habilitarPaginaBuscar = false;

    this.resource.obtenerHtmlPorUUID(uuid).subscribe(
      (resp) => {
        this.responseUuid = resp;

        for (let web of resp.elementos_web) {
          if (web.posicion == 'Pre-Header') {
            this.HeaderHtml = web;
          }
          else if (web.posicion == 'Footer') {
            this.FooterHtml = web;
          }
        }



        //enviado de datos del correo
        this.configuration = resp.configuration;
        localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

        //this.configurationEmit.emit(this.configuration);
        // console.warn(" this.configuration",  this.configuration);

        this.menuFooterHtml = resp.elementos_footer;
        this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);
        this.customHtml = null;
        // la pagina es de tipo slides 
        this.BotonesDeSlides = null;
        this.sliderHtml = null;
        this.tabsHtml = null;
        //la pagina es de tipo producs      
        this.productsHtml = null;


        this.mostrarActivos = true;

        this.initFullpage();
        $(".c-body").removeClass("overflow-hidden");
      }
    );
  }


  private procesarSlides(slides) {
    for (let slide of slides) {
      slide.titulo = slide.titulo.split('|');
    }
    return slides;
  }


  private initFullpage() {
    const $el = document.querySelector('#test-c');

    if ($el) {
      const html = `
            <script>

              if (!window.startIntro) {
                window.startIntro = true;
              }
              setTimeout(function () {
                if ($.fn.fullpage.destroy) {
                  $.fn.fullpage.destroy('all');
                  // console.warn("$.fn.fullpage.destroy");
                }

                setTimeout(function () {
                  $('#fullpage').fullpage({
                    // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                    menu: '#myMenu',
                    scrollingSpeed: 1000,
                    autoScrolling: true,
                    scrollOverflow: false,
                    resize: false,
                    
                    keyboardScrolling: false,
                    afterRender: function () {
                      var $map = document.getElementById('inner-map');
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-1');

                      $items.removeClass('custom-class-active');
                      $next.addClass('example custom-class-active');
                    },
                    afterResize: function(){
                      
                    },
                    onLeave: function(index, nextIndex, direction) {
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-'+nextIndex);

                      $items.removeClass('custom-class-active');
                      $next.addClass('custom-class-active');
                    }
                  });
                }, 100);

                setTimeout(function () {
                  $('#fullpage2').fullpage({
                    // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                    menu: '#myMenu',
                    scrollingSpeed: 1000,
                    autoScrolling: true,
                    scrollOverflow: false,
                    resize: false,
                    
                    keyboardScrolling: false,
                    afterRender: function () {
                      var $map = document.getElementById('inner-map');
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-1');

                      $items.removeClass('custom-class-active');
                      $next.addClass('example custom-class-active');
                    },
                    afterResize: function(){
                      
                    },
                    onLeave: function(index, nextIndex, direction) {
                      var $items = $('#myMenu li');
                      var $next = $('#fp-id-'+nextIndex);

                      $items.removeClass('custom-class-active');
                      $next.addClass('custom-class-active');
                    }
                  });
                }, 100);


              }, 75);
            </script>
      `;

      const fragment = document.createRange().createContextualFragment(html);
      $el.appendChild(fragment);
    }
  }

  private crearRowParaContenidoDeMenu(array) {
    let i, j, tempArray = [], chunk = 4;
    let innerArray = [];
    for (i = 0, j = array.length; i < j; i++) {
      if (array[i].html_icon !== '-' && array[i].descripcion !== ' ' && array[i].descripcion !== '') {
        innerArray.push(array[i]);
      }
    }
    for (i = 0, j = innerArray.length; i < j; i += chunk) {
      tempArray.push(innerArray.slice(i, i + chunk));
    }
    return tempArray;
  }

  private crearBotonesDeSlides(slides) {
    let nav = '';
    let eventsMove = '';

  

    

    // slides.map(({ html_icon, nombre,nombre_i, es_mapa }, index) => {
    //   const counter = index + 1;
    //   const selector = `fp-id-${counter}`;

    //   if (es_mapa == 1) {
    //     // console.warn("HAY UN MAPA");
    //     let data = {
    //       mode: "2"
    //     };

    //     this.obtenerLocations(data);
    //   }

    //   nav += `
    //     <li id="${selector}" ${index == 0 ? 'class="custom-class-active"' : ''}>
    //       <a href="#">
    //         <i  class="icono ${html_icon}"></i>
    //         <span  class="text">${nombre}</span>
            
    //       </a>
    //     </li>`;

    //   // console.warn(nav);


    //   eventsMove += `
    //     $('body').on('click', '#${selector}', function (event) {
    //       event.stopPropagation();
    //       $.fn.fullpage.moveTo(${counter});
    //     });
    //   `;
    // });

    $('#test-c').append(`<script>${eventsMove}</script>`);

    return nav;
  }

  public buscar(buscar) {
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.sliderHtml = null;
    this.tabsHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;

    this.habilitarPaginaBuscar = true;
  }

  public obtenerLocations(data) {
    this.resource.obtenerLocations(data).subscribe(resp => {
      //para que queden guardado los departamentos y no se reseten del select
      if (resp.filters) {
        this.departamentosEnCasoDeQueVengaVacioElNodo = resp.filters;
      }
      else {
        resp.filters = this.departamentosEnCasoDeQueVengaVacioElNodo;
      }
      this.mapa = resp;
    }, err => {
      this.mapa = null;
    });
  }

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
  }


}
